import { inIframe } from './in_iframe'
import isPWA from './is_pwa'
import appInfo from '@polleverywhere/slideware-bindings/lib/app_info'

export default function getPlatform (app) {
  if (inIframe()) {
    if (app.options.role === 'slideware') {
      // Google slides check
      const params = new URLSearchParams(document.location.search)
      if (params.has('iframe_url') && params.get('iframe_url').match(/google/)) {
        return 'google'
      }

      // document.referrer may be undefined or blank which will throw an exception
      try {
        const url = new URL(document.referrer)
        if (url.host.match(/google/i)) {
          return 'google'
        }
      } catch {}
    }

    return 'iframe'
  }

  if (isPWA()) {
    return 'pwa'
  }

  // MS Teams
  if (navigator.userAgent.match(/teams/i)) {
    return 'msteams'
  }

  // presenter|liveslides|electron
  const platform = appInfo.platform
  if (platform.length > 0) {
    return platform
  }

  // web|ios|android
  return window.Capacitor?.platform
}
